import { combineReducers } from 'redux'
import misc from './misc'
import accounting from './accounting'

export default combineReducers({
  misc,
  accounting,
})
